import { createContext, useContext, useState } from "react";

// Create Context
const BPBottlerSelectionContext = createContext();

// Context Provider Component
export const BPBottlerSelectionProvider = ({ children }) => {
    const [selectedData, setSelectedData] = useState([]);

    return (
        <BPBottlerSelectionContext.Provider value={{ selectedData, setSelectedData }}>
            {children}
        </BPBottlerSelectionContext.Provider>
    );
};

// Custom Hook for easy access
export const useBPBottlerSelection = () => useContext(BPBottlerSelectionContext);
